module.exports = __webpack_public_path__ + "img/upload.210a8971.svg";